export interface FaqItem {
  question: string
  answer: string[]
}

export const faqs: FaqItem[] = [
  {
    question: 'Come ricevo il materiale?',
    answer: [
      'Riceverai accesso immediato dopo il pagamento.',
      'I materiali sono digitali in formato PDF e possono essere consultati da computer, tablet o smartphone.',
    ],
  },
  {
    question: 'È solo per allenatori esperti?',
    answer: [
      'No.',
      'La struttura progressiva permette di partire dai fondamentali e procedere verso situazioni più complesse, scegliendo il lavoro più adatto al proprio gruppo.',
    ],
  },
  {
    question: 'Gli esercizi sono spiegati solo con testo?',
    answer: [
      'No.',
      'PALLAMANO 360™ utilizza sequenze visuali, diagrammi di campo, frecce, posizioni del corpo, errori/correzioni e spiegazioni sintetiche.',
    ],
  },
  {
    question: 'Posso adattare gli allenamenti al mio gruppo?',
    answer: [
      'Sì.',
      'Il sistema include strumenti per adattare esercizi e sedute in base al livello, al numero di giocatori, allo spazio e al tempo disponibile.',
    ],
  },
  {
    question: "Devo seguire le 72 sessioni esattamente nell'ordine?",
    answer: [
      'No.',
      "Puoi seguire la progressione completa oppure scegliere il volume e la seduta più adatti all'obiettivo della tua squadra.",
    ],
  },
  {
    question: 'È un prodotto fisico?',
    answer: [
      'No.',
      'PALLAMANO 360™ è un prodotto 100% digitale.',
      'Non riceverai libri fisici per posta.',
    ],
  },
  {
    question: 'Posso stampare il materiale?',
    answer: [
      'Sì.',
      "Puoi scaricare i PDF e stampare le pagine che vuoi utilizzare come riferimento durante l'allenamento.",
    ],
  },
  {
    question: 'Come funziona la garanzia di 7 giorni?',
    answer: [
      "Hai 7 giorni per verificare l'accesso e controllare che il materiale ricevuto corrisponda a quanto descritto nell'offerta.",
      'Se riscontri un problema, contattaci per permetterci di verificarlo e risolverlo.',
    ],
  },
]
